import { EbayBag } from '@/components/icons/EbayBag';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
  compact?: boolean;
}

/**
 * Small chip shown on inventory tiles/rows when the item currently has an
 * active (or pending) eBay listing owned by the current user. Solid gold-ish
 * accent to distinguish from the neutral "Unlisted" chip.
 */
export function EbayListedBadge({ className, compact = false }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-active-gold/40 bg-active-gold/10 text-active-gold uppercase tracking-wide whitespace-nowrap leading-none',
        compact ? 'text-[9px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5',
        className,
      )}
      title="Also listed on eBay"
    >
      <EbayBag className="h-2.5 w-2.5" />
      eBay
    </span>
  );
}
